<template>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Reports
            </h2>
        </template>
        <Page :submenus="submenus">
            <slot></slot>
        </Page>
    </BreezeAuthenticatedLayout>
</template>

<script setup>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import Page from '@/Components/Page'
import {usePage} from "@inertiajs/inertia-vue3";

const permissions = usePage().props.value.auth.user.role.permissions;
const submenus = [
    {
        'title': 'Fees Report',
        'active': route().current('report.*'),
        'route': route('report.academic', localStorage.branchId),
        'visible': permissions.find(permission => permission.name === 'View Report')
    }
];
</script>
